import { useContext } from 'react';
import { BusinessContext } from '@/contexts/BusinessContext';
import { invariant } from '@/utils/invariant';

export function useBusiness() {
  return invariant(useContext(BusinessContext), 'useBusiness must be used inside <BusinessProvider>.');
}
